import { useUserStore } from "@/store/user"
import { useStoryRingStore } from "@/store/storyRings"

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook("app:mounted", async () => {
    // This is used so when you do a browser refresh, we get updated user data.
    // Sometimes this is cached somehow and requires more than 1 browser refresh to fire....
    const userStore = useUserStore()
    userStore.getData()

    // Fetch story ring state for logged-in users
    const config = useRuntimeConfig()
    if (userStore.loggedIn) {
      const storyRingStore = useStoryRingStore()
      await storyRingStore.fetch(config.public.API_URL, userStore.token)
    }
  })
})
